'use client';

import { Select } from '@lichtblick/photon/molecules/select';

import { i18n } from '../../i18n';
import type { CitiesQuery } from '../../types/generated';

type CityFieldProps = {
  cities: CitiesQuery['citiesByPostcode'];
  label?: string;
  defaultValue?: string;
  name: string;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
};

export const CityField: React.FC<CityFieldProps> = ({ cities, defaultValue, name, label, onChange }) => (
  <Select
    data-testid={`select-${name}`}
    defaultValue={defaultValue ?? ''}
    emptyOptionLabel={cities.length === 0 ? 'Bitte auswählen' : undefined}
    errorMessage={cities?.length === 0 ? 'Bitte gib eine gültige PLZ ein.' : i18n.validation.missing}
    label={label ?? 'Ort'}
    name={name}
    onInvalid={(e) => {
      e.preventDefault();
    }}
    onChange={onChange}
    required
  >
    {[
      ...(cities.length > 1
        ? [
            <Select.Option hidden key="placeholder" value="">
              Bitte auswählen
            </Select.Option>,
          ]
        : []),
      ...(cities ?? []).map((city) => (
        <Select.Option key={city.cityId} value={city.name ?? ''}>
          {city.name}
        </Select.Option>
      )),
    ]}
  </Select>
);
